"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbHybridAuthenticator = void 0;
const framework_1 = require("../../../framework");
class MbHybridAuthenticator extends framework_1.BaseAuthenticator {
    constructor(session, getAccessToken) {
        super(session);
        this.doLogin = () => __awaiter(this, void 0, void 0, function* () {
            const accessToken = yield this.getAccessToken();
            return { accessToken };
        });
        this.doLogout = () => __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve();
        });
        this.getAccessToken = getAccessToken;
    }
}
exports.MbHybridAuthenticator = MbHybridAuthenticator;
//# sourceMappingURL=index.js.map